import { Controller } from "@hotwired/stimulus"

// This controller automatically scrolls a container to the bottom
// Useful for chat/messaging interfaces to always show newest content
export default class extends Controller {
  connect() {
    // Scroll to the bottom when the controller connects
    this.scrollToBottom()
    
    // Set up a MutationObserver to detect when new content is added
    this.observer = new MutationObserver(this.scrollToBottom.bind(this))
    
    // Start observing the container for added nodes
    this.observer.observe(this.element, { 
      childList: true,
      subtree: true
    })
  }
  
  disconnect() {
    // Clean up the observer when the controller disconnects
    if (this.observer) {
      this.observer.disconnect()
    }
  }
  
  scrollToBottom() {
    // Scroll to the bottom of the container
    this.element.scrollTop = this.element.scrollHeight
  }
}